/**
 * The one robots directive that keeps a response out of search indexes
 * (JET-2155): every stage response's `X-Robots-Tag`
 * (server/plugins/stage-noindex.ts), and a locked page's header and meta tag
 * (server/utils/passwordGate.ts, components/PasswordGate.vue). Isomorphic, so
 * the form and the server share it. Behind the Backoffice proxy the header is
 * lost (its ResponseForwarder passes only Content-Type); the meta tag is not.
 */
export const NOINDEX_NOFOLLOW = "noindex, nofollow"
